import { defineStore } from 'pinia';
import { ConfigService } from "@/services/config";

export interface ConfigState {
    captcha: {
        key: string;
        validateCaptchaForLogin: boolean;
        validateCaptchaForRegistration: boolean;
        validateCaptchaForPhoneSetup: boolean;
        validateCaptchaForSmsCode: boolean;
        validateCaptchaForResendActivation: boolean;
        validateCaptchaForPasswordReset: boolean;
    }
    authorizeNet: {
        apiLoginId: string;
        publicClientKey: string;
    }
    plans: API.Plan[];
    plansMap: Map<string, API.Plan>;
}

export const useConfigStore = defineStore('config', {
    state: (): ConfigState => {
        return {
            captcha: {
                key: "",
                validateCaptchaForLogin: false,
                validateCaptchaForRegistration: false,
                validateCaptchaForPhoneSetup: false,
                validateCaptchaForSmsCode: false,
                validateCaptchaForResendActivation: false,
                validateCaptchaForPasswordReset: false,
            },
            authorizeNet: {
                apiLoginId: "",
                publicClientKey: ""
            },
            plans: [],
            plansMap: new Map()
        };
    },
    actions: {
        async getConfig() {
            try {
                const config = await ConfigService.getConfig();
                this.captcha = config.captchaConfig;
                this.authorizeNet = config.authorizeNetConfig;
                this.plans = config.plans;
                this.plansMap.clear();
                this.plans.forEach(p=>{
                    this.plansMap.set(p.code,p);
                })
            } catch (err) {
                console.error("Error getting app config", err);
            }
        }
    }
})
